export const isIE = () => /*@cc_on!@*/ false || !!document.documentMode;
